import React, { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import Search from '../header/Search';
import ProfileOneIcon from '../svg/ProfileOneIcon';
import ReorderIcon from '../svg/ReorderIcon';
import HeartIcon from '../svg/HeartIcon';
import UserMenu from './UserMenu';
import Link from '@/components/common/Link';
// import { restoreLastOrder } from '@/utils/orderUtils';

function TopMenu({ items, color, generalSettingsStore }) {
  const [isClient, setIsClient] = useState(false);
  // const [isRestoring, setIsRestoring] = useState(false);
  const t = useTranslations('Account');

  useEffect(() => {
    setIsClient(true);

    const handleStorageChange = (e) => {
      if (e.key === 'token' && !e.newValue) {
        localStorage.removeItem('userData');
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const isLoggedIn = isClient ? !!localStorage.getItem('token') : false;
  const isFavoritesEnabled = generalSettingsStore.showFavorites;

  return (
    <div className="flex justify-between items-center h-2/5">
      <div className="flex items-center min-w-max">
        <Search />
      </div>
      <nav className="flex items-center justify-center h-1/2 min-w-max">
        <ul className="flex space-x-2 xl:space-x-4 font-semibold text-primary-studio text-sm xl:text-base">
          {items.map((item) => (
            <li key={`${item.url}-${item.title}`} className="border-s-2 ps-2 xl:ps-4 border-color-primary-studio">
              <Link href={item.url} className="flex items-center hover:underline whitespace-nowrap">
                {item.title}
              </Link>
            </li>
          ))}
          {isLoggedIn && isFavoritesEnabled && (
            <li className="border-s-2 ps-2 xl:ps-4 border-color-primary-studio">
              <Link href="/my-account?tab=my-favorites" className="flex items-center hover:underline whitespace-nowrap">
                <HeartIcon width="24" height="24" fill={color} className="inline me-1 h-4 w-4 xl:h-6 xl:w-6" />
                <span className="hidden md:inline">{t('my_favorites')}</span>
              </Link>
            </li>
          )}
          <li className="border-s-2 ps-2 xl:ps-4 border-color-primary-studio">
            {isLoggedIn ? (
              <UserMenu color={color} />
            ) : (
              <Link href="/login" className="hover:underline whitespace-nowrap">
                <span className="hidden md:inline">{t('login')}</span>
                <ProfileOneIcon width="24px" fill={color} className="inline ms-1 h-4 w-4 xl:h-6 xl:w-6" />
              </Link>
            )}
          </li>
          <li className="border-s-2 ps-2 xl:ps-4 border-color-primary-studio">
            {isLoggedIn ? (
              // <button
              //   onClick={() => restoreLastOrder(setIsRestoring)}
              //   disabled={isRestoring}
              //   className="flex items-center hover:text-primary-studio/80 transition-colors"
              //   title={t('restore_last_order')}
              // >
              //   <ReorderIcon width={20} height={20} color={color} className="inline me-1" />
              //   <span className="ml-2 hidden md:inline whitespace-nowrap">
              //     {isRestoring ? t('restoring') : t('restore_last_order')}
              //   </span>
              // </button>
              <Link
                href="/my-account?tab=my-orders"
                className="flex items-center hover:text-primary-studio/80 transition-colors"
              >
                <ReorderIcon width={20} height={20} color={color} className="inline me-1 h-4 w-4 xl:h-6 xl:w-6" />
                <span className="ml-2 hidden md:inline whitespace-nowrap">
                  {/* {isRestoring ? t('restoring') : t('restore_last_order')} */}
                  {t('restore_last_order')}
                </span>
              </Link>
            ) : (
              <Link href="/my-account?tab=my-orders" className="hover:underline whitespace-nowrap">
                <ReorderIcon width={20} height={20} color={color} className="inline me-1 h-4 w-4 xl:h-6 xl:w-6" />
                <span className="ml-2 hidden md:inline whitespace-nowrap">
                  {/* {isRestoring ? t('restoring') : t('restore_last_order')} */}
                  {t('restore_last_order')}
                </span>
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </div>
  );
}

TopMenu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  })).isRequired,
  color: PropTypes.string.isRequired,
  generalSettingsStore: PropTypes.object,
};

export default inject('generalSettingsStore')(observer(TopMenu));
